import { getUserInfoCall, helloWorldCall, loginCall, loadRolePermissionScripts } from "../../webservices/generic/authWs";
import { SIGN_IN, SIGN_OUT, TRY_SIGN_IN } from "./types";
import {saveToken, saveUser, saveAbp, clearSession} from '../../storage/sessionStorage';

export const trySignIn = (username, password) => {
    return (dispatch) => {
        dispatch({ type: TRY_SIGN_IN });
        //helloWorldCall();
        loginCall(username, password)
        .then(function (response) {
            if (response.data.success === true){
                let token = response.data.result;
                saveToken(token);
                getUserInfoCall()
                .then(function (infoResponse) {
                    if (infoResponse.data.success === true){

                        let payload = {
                            user: infoResponse.data.result.user,
                            token: token
                        }
                        saveUser(payload.user);
                        
                        //We get our abp script
                        loadRolePermissionScripts()
                        .then(function (abpRes){

                            //We create a script element and inject it as an HTML element so we can call the abp functions
                            const script = document.createElement('script');
                            script.innerHTML = abpRes.data;
                            script.type = 'text/javascript';
                            document.body.appendChild(script);    
                            script.onload = () => { 
                            };

//                            console.log('success!');
                            // console.log(window.abp.nav.menus.MainMenu.items.length);

                            //Now we have access to the abp functions in the window element of the application so we fetch the values we want to store in local storage
                            //Todo: We want to fetch permissions and other stuff too; not just Main Menu
                            var abp = {
                                MainMenu: window.abp.nav.menus.MainMenu
                            }
                            console.log('this is all of abp:');
                            console.log(window.abp);
                            saveAbp(abp);
                            dispatch({ type: SIGN_IN, payload: payload });
                        })
                        .catch(function (err){
                            console.log('Error fetching abp roles and permissions scripts');
                        })

                    }
                })
                .catch(function (error) {
                    console.log(error);
                })
            }
            else {
                dispatch({ type: SIGN_IN, payload: {authError: 'Login Failed'} });
            }
        })
        .catch(function (error) {
            dispatch({ type: SIGN_IN, payload: {authError: 'Login Failed'} });
        })
    }
}

export const signOut = () => {
    return (dispatch) => {
        clearSession();
        dispatch({ type: SIGN_OUT });
    }
}